import type { ColumnDefinition } from "@frui.ts/dataviews";
import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import type BlacklistedEmailAddress from "entities/blacklistedEmailAddress";
import EmailBlacklistsViewModel from "viewModels/administration/emailBlacklist/emailBlacklistsViewModel";
import { formatDateTime } from "utils/localizations";
import ListView from "../../common/list";
import EmailBlacklistFilters from "./emailBlacklistFilters";
import EmailBlacklistActionMenu from "./emailBlacklistActionMenu";

const EmailBlacklistsView: ViewComponent<EmailBlacklistsViewModel> = observer(({ vm }) => {
  const cellClassName = "text-nowrap";
  const cellClassNameRight = "text-nowrap text-right";
  const headerClassNameRight = "text-right";

  const columns: ColumnDefinition<BlacklistedEmailAddress>[] = [
    {
      title: vm.translateAttribute("emailAddressSearchPattern"),
      property: "emailAddressSearchPattern",
      cellClassName,
    },
    {
      title: vm.translateAttribute("description"),
      property: "description",
      cellClassName,
    },
    {
      title: vm.translateAttribute("validSince"),
      property: "validSince",
      valueFormatter: props => (props.item.validSince ? formatDateTime(props.item.validSince) : "–"),
      cellClassName: cellClassNameRight,
      headerClassName: headerClassNameRight,
    },
    {
      title: vm.translateAttribute("validUntil"),
      property: "validUntil",
      valueFormatter: props => (props.item.validUntil ? formatDateTime(props.item.validUntil) : "–"),
      cellClassName: cellClassNameRight,
      headerClassName: headerClassNameRight,
    },
    {
      title: vm.translateAttribute("updatedAt"),
      property: "updatedAt",
      valueFormatter: props => (props.item.updatedAt ? formatDateTime(props.item.updatedAt) : "–"),
      cellClassName: cellClassNameRight,
      headerClassName: headerClassNameRight,
    },
    {
      title: vm.translateAttribute("updatedBy"),
      property: "updatedBy",
      cellClassName,
    },
    {
      cellClassName: "text-align-end",
      valueFormatter: props => <EmailBlacklistActionMenu vm={vm} item={props.item} />,
    },
  ];

  return (
    <ListView
      columns={columns}
      vm={vm}
      aboveTable={<EmailBlacklistFilters vm={vm} />}
      hideButtons={true}
      showDetailWithList={true}
    />
  );
});

registerView(EmailBlacklistsView, EmailBlacklistsViewModel);
